// extracted by mini-css-extract-plugin
export default {"root":"UnderwritingStepSection_root__QL8VA","title":"UnderwritingStepSection_title__ZLnE1","addButton":"UnderwritingStepSection_addButton__doZhi"};